
import { Activity } from 'lucide-react'
import { Skeleton } from '@/components/ui/skeleton'

interface DashboardMetricProps {
  label: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: string | number | any
  subValue?: string
  trend?: number
  loading?: boolean
}

export function DashboardMetric({ label, value, subValue, trend, loading }: DashboardMetricProps) {
  if (loading) {
    return (
      <div className="flex flex-col gap-2 p-5 border bg-card/50">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-8 w-16" />
        <Skeleton className="h-3 w-32" />
      </div>
    )
  }

  return (
    <div className="flex flex-col justify-between p-5 border bg-card hover:bg-muted/5 transition-colors group relative overflow-hidden">
      <div className="absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity">
        <Activity className="h-12 w-12" />
      </div>
      
      <div>
        <p className="text-xs font-mono text-muted-foreground uppercase tracking-wider mb-1">{label}</p>
        <h3 className="text-3xl font-bold tracking-tight font-sans">{value}</h3>
      </div>
      
      {subValue && (
        <div className="mt-4 flex items-center gap-2 text-xs font-medium">
           {trend !== undefined && (
             <span className={`${trend >= 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>
               {trend > 0 ? '+' : ''}{trend}%
             </span>
           )}
           <span className="text-muted-foreground/70">{subValue}</span>
        </div>
      )}
    </div>
  )
}
